import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationId } from "./constants";
import type { Transformation, UpdateTransformationRequest } from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

export const updateTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationId,
  async ({
    transformation_id: transformationId,
    propagate_errors: propagateErrors,
    ...transformation
  }: UpdateTransformationRequest): Promise<Transformation> => {
    return fetch(
      `/apps/transformations/${transformationId}`,
      "PATCH",
      transformation,
      {},
      {
        propagateFetchRequestError: propagateErrors ?? true,
      }
    );
  }
);
